export default {
  loading: false,
  cpuStats: [],
  ramStats: [],
  errorMessages: []
};
